import { OpenAPIEmptyExample } from './OpenAPIExample';
import { OpenAPIMediaTypeContent } from './OpenAPIMediaType';
import { getOpenAPIClientContext } from './context';
import { getExamples } from './util/example';
import { createStateKey } from './utils';
export function OpenAPIWebhookExample(props) {
    var data = props.data, context = props.context;
    var operation = data.operation;
    var items = (function () {
        if (!operation.requestBody) {
            return [];
        }
        return Object.entries(operation.requestBody.content).map(function (_a) {
            var key = _a[0], value = _a[1];
            var schema = value.schema;
            if (!schema) {
                return {
                    key: key,
                    label: key,
                    body: <OpenAPIEmptyExample context={context}/>,
                };
            }
            return {
                key: key,
                label: key,
                body: <></>,
                examples: getExamples({
                    mediaTypeObject: value,
                    mediaType: key,
                    context: context,
                }),
            };
        });
    })();
    return (<div className="openapi-panel">
            <h4 className="openapi-panel-heading">Payload</h4>
            <div className="openapi-panel-body">
                <OpenAPIMediaTypeContent selectIcon={context.icons.chevronDown} stateKey={createStateKey('request-body-media-type', context.blockKey)} items={items} context={getOpenAPIClientContext(context)}/>
            </div>
        </div>);
}
